const gatsbyBrowser = require("./dist/gatsby-browser");

module.exports = gatsbyBrowser;
